<template>
  <div class="course_table grey loading_table">
    <b-loading :is-full-page="false" :active="isLoading"></b-loading>
    <b-table
      default-sort="name"
      ref="table"
      pagination-simple
      per-page="15"
      :data="userCourses"
      paginated
      checkable
      :checked-rows.sync="rows.checked"
      detailed
      :show-detail-icon="false"
      @click="openInfo"
    >
      <template slot-scope="props">
        <b-table-column label="Название курса" :visible="true" field="name" :centered="false" sortable>
          <div>{{ props.row.name }}</div>
        </b-table-column>
        <b-table-column label="Категория" :visible="true" field="category.name" :centered="false" sortable>
          <div>{{ props.row.category.name }}</div>
        </b-table-column>
        <b-table-column label="Статус" :visible="true" field="status" :centered="false" sortable>
          <div>{{ setStatus(props.row.status) }}</div>
        </b-table-column>
        <b-table-column label="Начало" :visible="true" field="date_start" :centered="false" sortable>
          <div>{{ props.row.date_start | moment('DD.MM.YYYY') }}</div>
        </b-table-column>
        <b-table-column label="Окончание" :visible="true" field="date_end" :centered="false" sortable>
          <div>{{ props.row.date_start | moment('add', props.row.days_limit + ' day', 'DD.MM.YYYY') }}</div>
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        <div class="table_actions">
          <button class="restore_course" @click="$emit('delete', props.row.id)">
            <i class="mdi mdi-file-document-box-remove-outline"></i> Убрать курс из списка
          </button>
          <button class="add_course">
            <router-link :to="'/courses/' + props.row.id">
              <i class="mdi mdi-chart-areaspline"></i> Статистика
            </router-link>
          </button>
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    userCourses: {
      default: () => [],
      type: Array
    },
    rows: {
      default: () => {},
      type: Object
    },
    isLoading: {
      default: () => true,
      type: Boolean
    }
  },
  data() {
    return {
      openedRow: {}
    }
  },
  methods: {
    openInfo(row) {
      if (row != this.openedRow) {
        this.$refs.table.toggleDetails(this.openedRow)
        this.$refs.table.toggleDetails(row)
        this.openedRow = row
        return
      }
      this.$refs.table.toggleDetails(row)
      this.openedRow = {}
    },
    setStatus(status) {
      switch (status) {
        case 0:
          return 'Назначен'
        case 1:
          return 'В процессе'
        case 2:
          return 'Пройден'
        case 3:
          return 'Не пройден'
      }
    }
  }
}
</script>
